import React from 'react';
import UserLookupForm from './UserLookupForm';
import './UserLookupForm.css';

function App() {
    const today = new Date();
    return (
        <div className="container">
            <div className="usernamebox">
                <UserLookupForm />
            </div>
            <div className="section-footer divfooter">
                <p className="pfooter">&copy; {today.getFullYear()} eMoney Advisor, LLC.</p>
                <div>
                    <a href="/ema/Legal/Terms?ema%2fapimanagement">Terms of Use</a>
                    &nbsp;&nbsp;
                    <a href="/ema/Legal/Security?ema%2fapimanagement">Security</a>
                    &nbsp;&nbsp;
                    <a href="/ema/Legal/Privacy?ema%2fapimanagement">Privacy Notice</a>
                </div>
            </div>
        </div>

  );
}

export default App;
